<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    name: string
    placeholder?: string
    label?: string
    type?: `text` | `email` | `password`
    error?: string
    autocomplete?: 'on' | 'off'
    disabled?: boolean
  }>(), {
    type: `text`,
    autocomplete: 'on',
  },
);

defineEmits<{
  focus: []
  blur: []
}>();

const modelValue = defineModel<string>();

const hasError = computed(() => !!props.error);
</script>

<template>
  <div class="group">
    <IadLabel
      :html-for="name"
      :text="label"
      :error
    />
    <input
      :id="name"
      v-model="modelValue"
      :name
      :type
      :disabled
      class="border focus:border-secondary outline-none peer
        placeholder:text-neutral placeholder:font-medium
        block w-full px-s py-xs rounded-md
      "
      :class="{
        'border-neutral-30': !hasError,
        'border-error': hasError,
        'text-neutral bg-neutral-90': disabled,
      }"
      :placeholder
      :autocomplete
      @focus="$emit('focus')"
      @blur="$emit('blur')"
    >
    <IadInputError :error />
  </div>
</template>
